import { create } from 'zustand';
import apiClient from '../api/client';
import { onTokenChange, getRefreshToken } from '../api/tokenManager';

function loadUser() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const useAuthStore = create((set, get) => ({
  // State
  user: loadUser(),
  accessToken: localStorage.getItem('accessToken') || null,
  refreshToken: localStorage.getItem('refreshToken') || null,
  isAuthenticated: !!localStorage.getItem('accessToken'),
  tenantSlug: localStorage.getItem('tenantSlug') || null,
  tenant: null,

  // Actions
  setAuth: ({ user, accessToken, refreshToken, tenantSlug }) => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
    if (tenantSlug) {
      localStorage.setItem('tenantSlug', tenantSlug);
    }
    set({
      user,
      accessToken,
      refreshToken,
      isAuthenticated: true,
      tenantSlug: tenantSlug || get().tenantSlug,
    });
  },

  clearAuth: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tenantSlug');
    localStorage.removeItem('user');
    set({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      tenantSlug: null,
      tenant: null,
    });
  },

  setUser: (user) => {
    if (user) localStorage.setItem('user', JSON.stringify(user));
    set({ user });
  },

  updateUser: (updates) =>
    set((state) => {
      const updated = state.user ? { ...state.user, ...updates } : null;
      if (updated) localStorage.setItem('user', JSON.stringify(updated));
      return { user: updated };
    }),

  fetchTenant: async (slug) => {
    try {
      const { data } = await apiClient.get(`/tenants/by-slug/${slug}`);
      set({ tenant: data, tenantSlug: slug });
      localStorage.setItem('tenantSlug', slug);
      return data;
    } catch (error) {
      console.error('Failed to fetch tenant branding:', error);
      return null;
    }
  },
}));

// A silent token refresh (triggered by a 401, the socket, or a tab wake) rotates the
// token behind the store's back. Without this the store keeps serving the token it
// read at module load, which is what made a stale socket survive until a second reload.
onTokenChange((accessToken) => {
  useAuthStore.setState({
    accessToken,
    refreshToken: getRefreshToken(),
    isAuthenticated: !!accessToken,
  });
});

export default useAuthStore;
